@use "../../styles/variables" as v;

.cnc-icon,
.cnc-icon-component {
  transition:
    color 0.15s ease,
    fill 0.15s ease;

  // critical layout rule:
  // preserve icon minimum size when icon is a direct child in a flexbox container.
  // Otherwise, due to the scalable nature of SVG, icon can shrink to becoming nearly invisible if the flexbox has limited space itself
  flex-shrink: 0;
}

.cnc-icon {
  width: 16px;
  height: 16px;

  &.sm {
    width: v.$unit;
    height: v.$unit;
  }
  &.lg {
    width: 20px;
    height: 20px;
  }

  &.xl {
    width: 24px;
    height: 24px;
  }

  &.link {
    fill: v.$c_navigate-icon-link-inactive;
    &:hover {
      fill: v.$c_navigate-icon-link-hover;
    }
    &:active {
      fill: v.$c_navigate-icon-link-active;
    }
  }
}

// Keep component icons aligned with Magnetic button icon colors
.mds-button .cnc-icon-component {
  color: var(--mds-button-icon-color);
}
